<template>
  <div class="card col-md-3">
    <h1>Input Text ({{ fieldData.field_name }})</h1>
      <div v-if="false">
        <div class="form-group">
          <div style="height: 150vh">Blank space</div>

          <field-info :fieldData="fieldData"></field-info>

          <input-text :fieldData="fieldData"></input-text>

          <field-subtext :fieldData="fieldData"></field-subtext>

          <field-messages :fieldData="fieldData"></field-messages>
        </div>
      </div>
  </div>
</template>

<script>
import InputText from '../interactive/InputText';
import InputRadio from '../interactive/InputRadio';
import InputCheckbox from '../interactive/InputCheckbox';
import InputMulticheckbox from '../interactive/InputMulticheckbox';
import InputSelect from '../interactive/InputSelect';
import FieldInfo from './FieldInfo';
import FieldTooltip from './FieldTooltip';
import FieldMessages from './FieldMessages';
import FieldSubtext from './FieldSubtext';

/* eslint-disable */
export default {
  props: ["fieldData"],
  components: {
    InputText,
    InputRadio,
    InputCheckbox,
    InputMulticheckbox,
    InputSelect,
    FieldInfo,
    FieldTooltip,
    FieldMessages,
    FieldSubtext,
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.scrolling-wrapper .card {
  flex: 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/ContentCard.vue?3ff15c72